import { combineReducers } from 'redux'
import { routerReducer } from 'react-router-redux'
import devicebitsRouter from '../containers/App/reducer'
import faqReducer from '../containers/Faq/reducer'
import guideReducer from '../containers/Guide/reducer'
import tutorialsReducer from '../containers/Tutorials/reducer'
import relatedReducer from '../containers/RelatedContent/reducer'
import deviceReducer from '../containers/DeviceSlider/reducer'
import trendingTopicsReducer from '../containers/TrendingTopics/reducer'
import linksReducer from '../containers/LaunchPad/reducer'
import breadcrumbsReducer from '../containers/Breadcrumbs/reducer'
import searchReducer from '../containers/ESSearch/reducer'
import osearchReducer from '../containers/Osearch/reducer'
import mailerReducer from '../containers/ContentMailer/reducer'
import suggestedReducer from '../containers/SuggestedContent/reducer'
import faqListReducer from '../containers/FaqList/reducer'
import helpfulTopicsReducer from '../containers/HelpfulTopics/reducer'
import tutorialListReducer from '../containers/TutorialList/reducer'
import callControlReducer from '../containers/CallHandler/reducer'
import feedbackReducer from '../containers/Feedback/reducer'
import recentsReducer from '../containers/RecentTopics/reducer'
import homeReducer from '../containers/Home/reducer'
import favouritesReducer from '../containers/Favourites/reducer'
import bulletinReducer from '../containers/Bulletin/reducer'
import footprintsReducer from '../containers/Footprints/reducer'
import freeNavReducer from '../containers/FreeNavSlider/reducer'

const rootReducer = combineReducers({
  devicebits: devicebitsRouter,
  routing: routerReducer,
  faq: faqReducer,
  guide: guideReducer,
  tutorials: tutorialsReducer,
  related: relatedReducer,
  devices: deviceReducer,
  trending: trendingTopicsReducer,
  breadcrumbs: breadcrumbsReducer,
  search: searchReducer,
  osearch: osearchReducer,
  mailer: mailerReducer,
  suggested: suggestedReducer,
  faqs: faqListReducer,
  helpfulTopics: helpfulTopicsReducer,
  tutorialList: tutorialListReducer,
  callControl: callControlReducer,
  feedback: feedbackReducer,
  recents: recentsReducer,
  home: homeReducer,
  favourites: favouritesReducer,
  bulletin: bulletinReducer,
  footprints: footprintsReducer,
  freeNav: freeNavReducer,
  launch: linksReducer
})

export default rootReducer
